import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfiguracaoMinimo } from 'pages/compra/configuracao-minimo/types';

export function useQueryConfiguracaoMinimo() {
    const requestListagem = useRequestListagem();

    return useQuery<ConfiguracaoMinimo>({
        queryKey: ['carrinho-configuracao-minimo'],
        queryFn: () => requestListagem({ url: '/gestao/configuracaogeralpedidominimo/ativo' }).then((res) => res.data.data),
    });
}
